import { render, staticRenderFns } from "./PublicDDSReport.vue?vue&type=template&id=16d5885d&scoped=true"
import script from "./PublicDDSReport.vue?vue&type=script&lang=js"
export * from "./PublicDDSReport.vue?vue&type=script&lang=js"
import style0 from "./PublicDDSReport.vue?vue&type=style&index=0&id=16d5885d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5885d",
  null
  
)

export default component.exports